import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _secificProductBaseUrl = "/Customer/Product";
const secificProduct = axios.create({
  baseURL: checkEnvironment(_basic, _secificProductBaseUrl)
});



/**
 * @param {string} orderCode
 * @param {number} langId
 * @param {number} productId
 */
export const getSecificProduct = async (orderCode, langId, productId, storeID, createAt) => {
  return await secificProduct.get("/GetOrderQueryProduct", {
    params: {
      orderCode,
      languageID: langId,
      productID: productId,
      storeID,
      createAt
    }
  });
};

export const postOrderEditProduct = async secificProductData => {
  return await secificProduct.post("/SetOrderAddProduct", secificProductData);
};
